export default __webpack_public_path__ + "static/media/Totem30.251266b5.jpg";